import {
  SET_ACTIVE,
  SET_KEY
} from './types'

export const state = {
  active: localStorage.getItem('webviewActive'),
  key: localStorage.getItem('webviewKey')
}

export const mutations = {
  [SET_ACTIVE] (state, value) {
    localStorage.setItem('webviewActive', value)
    state.active = value
  },
  [SET_KEY] (state, value) {
    localStorage.setItem('webviewKey', value)
    state.key = value
  }
}

export const actions = {
  init ({ commit }, key) {
    commit(SET_ACTIVE, true)
    commit(SET_KEY, key)
  },
}

export const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app/webview.js